// import useAction from "@/commonJS/Actions/actions";
import { useAppState } from "@/context/AppStateContext";
// import { updateCountdownState } from "@/redux/features/layout/layoutSlice";
// import { useAppDispatch } from "@/redux/hooks";
import { useEffect, useState } from "react";

export default function useCountDown() {
  const [secondsLeft, setSecondsLeft] = useState(0);
  // const [action, setAction] = useState<any>(null);
  const [key, setKey] = useState("");
  // const dispatch = useAppDispatch();
  const {dispatch} = useAppState();

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timeout = setTimeout(() => {
      setSecondsLeft(secondsLeft - 1);
      dispatch({
        type: "SET_COUNT_STATE",
        payload: { secondsLeft: secondsLeft - 1, key: key }
      });
    }, 1000);

    return () => clearTimeout(timeout);

  }, [secondsLeft]);

  function start(seconds: number,key:string,actionAfterCountDown:Function) {
    setKey(key);
    setSecondsLeft(seconds);
    
    const timer = setTimeout(()=>{
      actionAfterCountDown();
    },(Number(seconds)*1000));

    return ()=>clearTimeout(timer);
  }

  return { secondsLeft, start };

}